/**
 * RequireB2BAuth — gate for /admin and /firm routes.  Redirects to
 * /b2b/login when the caller isn't signed into Supabase Auth.
 */

import { Navigate, useLocation } from "react-router-dom";
import { useSupaAuth } from "@/context/SupaAuthContext";

export default function RequireB2BAuth({ children }) {
  const { isAuthed, loading } = useSupaAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-[#F5F1E8] text-slate-600">
        Loading…
      </div>
    );
  }

  if (!isAuthed) {
    const next = encodeURIComponent(location.pathname + location.search);
    return <Navigate to={`/b2b/login?next=${next}`} replace />;
  }

  return children;
}
